<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="auto">
        <v-menu offset-y>
          <template
            v-slot:activator="{ on, attrs }"
          >
            <v-btn
              class="pa-4 text-none"
              rounded
              v-bind="attrs"
              small
              :color="date.length ? 'primary' : ''"
              v-on="on"
            >
              Periodo: {{ value.periodo.selected }}
              <v-icon
                right
              >
                mdi-menu-down
              </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(item, i) in selectPeriodosNames"
              :key="i"
              active-class="custom-active"
              @click="changeSelectList(item)"
            >
              <v-list-item-title
                :key="i"
                :value="item"
              >
                {{ item }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
      <v-col cols="auto">
        <v-menu
          offset-y
          rounded="lg"
        >
          <template
            v-slot:activator="{ on, attrs }"
          >
            <v-btn
              class="pa-4 text-none"
              rounded
              v-bind="attrs"
              small
              :color="date.length ? 'primary' : ''"
              v-on="on"
            >
              Outros Filtros
              <v-icon
                right
              >
                mdi-menu-down
              </v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item
              v-for="(item, i) in filtros"
              :key="i"
              dense
              active-class="custom-active"
            >
              <v-menu
                offset-x
                rounded="lg"
                :close-on-content-click="false"
              >
                <template v-slot:activator="{ on: onSubmenu, attrs: attrsSubmenu }">
                  <v-list-item-title
                    v-bind="attrsSubmenu"
                    class="d-flex align-center justify-space-between"
                    v-on="onSubmenu"
                  >
                    {{ item.name }}
                    <v-icon class="ml-2">
                      mdi-menu-down
                    </v-icon>
                  </v-list-item-title>
                </template>
                <v-list max-height="400">
                  <v-list-item-group
                    v-model="select"
                    color="indigo"
                    @change="(value) => setFiltro(value, item.name, item.paramentro)"
                  >
                    <v-list-item
                      v-for="(subItem, index) in item.value"
                      :key="index"
                      :value="subItem"
                      dense
                      active-class="custom-active"
                    >
                      <v-list-item-title>
                        {{ subItem.nome }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="!item.value.length"
                      disabled
                      dense
                    >
                      <v-list-item-title>
                        Nenhum item disponível
                      </v-list-item-title>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
      <v-col
        v-if="value.filtro.nome"
        cols="auto"
      >
        <v-chip
          close
          color="indigo darken-3"
          outlined
          @click:close="limparFiltro"
        >
          {{ value.filtro.nome }}: {{ value.filtro.value.nome }}
        </v-chip>
      </v-col>
      <v-col cols="auto">
        <v-btn
          class="pa-4 text-none"
          color="primary"
          rounded
          small
          @click="submit"
        >
          <v-icon left>
            mdi-filter
          </v-icon>
          Filtrar
        </v-btn>
      </v-col>
      <v-dialog
        v-model="dialog"
        max-width="500"
      >
        <v-toolbar
          color="primary"
          dark
        >
          <v-toolbar-title class="headline">
            Selecione o período
          </v-toolbar-title>
          <v-spacer />
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card>
          <v-card-text>
            <v-row justify="center">
              <v-col cols="auto">
                <data-field
                  v-model="dateFrom"
                  :label="'Data Inicial'"
                  :data-max="dateTo"
                  :mes-ano="mensal"
                />
              </v-col>
              <v-col cols="auto">
                <data-field
                  v-model="dateTo"
                  :label="'Data Final'"
                  :data-min="dateFrom"
                  :mes-ano="mensal"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="error"
              class="text-none"
              rounded
              @click="dialog = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              class="text-none"
              color="primary"
              rounded
              @click="selectPeriodo"
            >
              Confirmar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
  import hash from 'object-hash'
  import moment from 'moment'
  export default {
    name: 'PeriodSelect',
    props: {
      value: {
        type: Object,
        default: () => ({
          name: null,
          periodo: {
            label: 0,
            selected: 'Trimestre',
            from: null,
            to: null,
          },
          filtro: {
            nome: null,
            value: [],
            paramentro: null,
          },
        }),
      },

      selectPeriodosNames: {
        type: Array,
        default: () => [
          'Semana',
          'Mês',
          'Trimestre',
          'Semestre',
          'Selecionar período',
        ],
      },

      bootstrap: {
        type: Function,
        default: () => () => {},
      },

      mensal: {
        type: Boolean,
        default: false,
      },

      filtros: {
        type: Array,
        default: () => null,
      },

    },

    data () {
      return {
        moment,
        dialog: false,
        date: [],
        dateFrom: moment().startOf('month').format('YYYY-MM-DD'),
        dateTo: moment().format('YYYY-MM-DD'),
        select: null,
      }
    },

    created () {
      const { nome } = this.$user.get()
      const storage = localStorage.getItem('PeriodSelect-' + hash(this.value.name) + '-' + nome, JSON.stringify(this.value))
      const headerSave = JSON.parse(storage)
      if (headerSave) {
        Object.assign(this.value, headerSave)
      }
      this.changeSelectList(this.value.periodo.selected, this.value.periodo.from, this.value.periodo.to)
      this.submit()
    },

    methods: {
      limparFiltro () {
        this.value.filtro = { nome: null, value: [], paramentro: null }
      },
      changeSelectList (item, from = null, to = null) {
        switch (item) {
          case 'Semana':
            from = this.moment().subtract(6, 'days').format('YYYY-MM-DD')
            to = this.moment().format('YYYY-MM-DD')
            this.saveValue(item, from, to, 0)
            break
          case 'Mês':
            this.selectMes(item)
            break
          case 'Trimestre':
            this.selectTrimetre(item)
            break
          case 'Semestre':
            this.selectSemestre(item)
            break
          case 'Ano':
            from = this.moment().subtract(11, 'months').startOf('month').format('YYYY-MM-DD')
            to = this.moment().endOf('month').format('YYYY-MM-DD')
            this.saveValue(item, from, to, 5)
            break
          default:
            if (from && to) {
              this.dateFrom = from
              this.dateTo = to
              this.selectPeriodo()
            } else {
              this.dialog = true
            }
            break
        }
      },

      selectMes (item) {
        if (this.mensal) {
          const from = this.moment().startOf('month').format('YYYY-MM-DD')
          const to = this.moment().endOf('month').format('YYYY-MM-DD')
          this.saveValue(item, from, to, 2)
        } else {
          const from = this.moment().subtract(1, 'month').format('YYYY-MM-DD')
          const to = this.moment().format('YYYY-MM-DD')
          this.saveValue(item, from, to, 2)
        }
      },

      selectTrimetre (item) {
        if (this.mensal) {
          const from = this.moment().subtract(2, 'months').startOf('month').format('YYYY-MM-DD')
          const to = this.moment().endOf('month').format('YYYY-MM-DD')
          this.saveValue(item, from, to, 3)
        } else {
          const from = this.moment().subtract(3, 'months').format('YYYY-MM-DD')
          const to = this.moment().format('YYYY-MM-DD')
          this.saveValue(item, from, to, 3)
        }
      },

      selectSemestre (item) {
        if (this.mensal) {
          const from = this.moment().subtract(5, 'months').startOf('month').format('YYYY-MM-DD')
          const to = this.moment().endOf('month').format('YYYY-MM-DD')
          this.saveValue(item, from, to, 4)
        } else {
          const from = this.moment().subtract(6, 'months').format('YYYY-MM-DD')
          const to = this.moment().format('YYYY-MM-DD')
          this.saveValue(item, from, to, 4)
        }
      },

      selectPeriodo () {
        const dateStart = this.moment(this.dateFrom)
        const dateEnd = this.moment(this.dateTo)
        if (dateEnd.diff(dateStart, 'months', true) >= 12) {
          return window.Toast.fire({
            icon: 'error',
            title: 'Não permitido período maior que 1 ano',
          })
        }
        if (this.mensal) {
          this.dateFrom = dateStart.startOf('month').format('YYYY-MM-DD')
          this.dateTo = dateEnd.endOf('month').format('YYYY-MM-DD')
        }
        this.dialog = false
        this.saveValue(`${dateStart.format('DD/MM/YYYY')} - ${dateEnd.format('DD/MM/YYYY')}`, this.dateFrom, this.dateTo, 6)
      },

      saveValue (period, from, to, label = null) {
        Object.assign(this.value.periodo, {
          from: from,
          to: to,
          label: label,
          selected: period,
        })
      },

      returnDescricao (item) {
        if (!item.length) {
          return 'Todas'
        }
        if (item.length === 1) {
          return item[0].nome
        }
        const nomes = item.map((item) => item.nome)
        const retorno = nomes.join(', ')
        if (retorno.length > 20) {
          return `${item.length} selecionados`
        }
        return retorno
      },

      clearFilter (nome = null) {
        if (nome) {
          const index = this.itensFiltro.findIndex((item) => item.name === nome)
          this.itensFiltro[index].selected = []
        } else {
          this.itensFiltro.forEach((item) => {
            item.selected = []
          })
        }
      },
      submit () {
        const { nome } = this.$user.get()
        localStorage.setItem('PeriodSelect-' + hash(this.value.name) + '-' + nome, JSON.stringify(this.value))
        let parametros = null

        if (this.value.filtro) {
          parametros = {
            id: this.value.filtro.value.id,
            tipo: this.value.filtro.paramentro,
          }
        }

        this.bootstrap({ from: this.value.periodo.from, to: this.value.periodo.to, parametros })
      },
      setFiltro (dados, name, paramentro) {
        this.value.filtro = {
          nome: name,
          value: dados,
          paramentro: paramentro,
        }
      },
    },
  }
</script>

<style scoped>
  .v-item-group {
    background-color: rgb(255, 255, 255) !important;
    /* max-height: 200px; */
  }
  .v-menu__content {
    background-color: rgb(255, 255, 255) !important;
  }
</style>
